import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="py-16 text-center">
      <p className="mb-2 text-sm uppercase tracking-wide text-candy-ink-muted dark:text-candy-dark-ink-muted">
        404
      </p>
      <h1 className="mb-2 text-2xl font-semibold text-candy-ink dark:text-candy-dark-ink">Page not found</h1>
      <p className="mb-4 text-candy-ink-muted dark:text-candy-dark-ink-muted">
        That page does not exist in The Sweet Spot.
      </p>
      <Link to="/" className="text-candy-pink underline dark:text-candy-pink-dark">
        Back to home
      </Link>
    </div>
  );
}
